"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGraphic = void 0;
const core_1 = require("@mapmaker/core");
const useProjectState_1 = require("../../useProjectState");
const useFeature_1 = __importDefault(require("../useFeature"));
function useGraphic(graphicId) {
    const { feature: graphic, featureInput: graphicInput } = (0, useFeature_1.default)(graphicId, "GRAPHIC");
    const { outputType } = (0, useProjectState_1.useProjectFile)();
    if (!graphic) {
        return {
            graphic: null,
            graphicInput: null,
        };
    }
    const usableGraphic = (0, core_1.getGraphicForOutputType)(graphic, outputType);
    return {
        graphic: usableGraphic,
        graphicInput: graphicInput,
    };
}
exports.useGraphic = useGraphic;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlR3JhcGhpYy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3Byb2plY3QvZmVhdHVyZXMvZ3JhcGhpYy91c2VHcmFwaGljLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSx5Q0FJd0I7QUFDeEIsMkRBQXVEO0FBQ3ZELCtEQUF1QztBQUV2QyxTQUFnQixVQUFVLENBQUMsU0FBUztJQUNsQyxNQUFNLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxZQUFZLEVBQUUsWUFBWSxFQUFFLEdBQUcsSUFBQSxvQkFBVSxFQUdqRSxTQUFTLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFFeEIsTUFBTSxFQUFFLFVBQVUsRUFBRSxHQUFHLElBQUEsZ0NBQWMsR0FBRSxDQUFDO0lBRXhDLElBQUksQ0FBQyxPQUFPLEVBQUU7UUFDWixPQUFPO1lBQ0wsT0FBTyxFQUFFLElBQUk7WUFDYixZQUFZLEVBQUUsSUFBSTtTQUNuQixDQUFDO0tBQ0g7SUFFRCxNQUFNLGFBQWEsR0FBRyxJQUFBLDhCQUF1QixFQUFDLE9BQU8sRUFBRSxVQUFVLENBQUMsQ0FBQztJQUVuRSxPQUFPO1FBQ0wsT0FBTyxFQUFFLGFBQWE7UUFDdEIsWUFBWSxFQUFFLFlBQVk7S0FDM0IsQ0FBQztBQUNKLENBQUM7QUFyQkQsZ0NBcUJDIn0=